import Checkbox from './Checkbox'
import cn from 'classnames'
import type {ChangeEventHandler, CSSProperties, ReactNode} from "react"
import type {ClassValue} from '../helpers/react-helpers'
import {useTestId} from '../contexts/testid'
import {toBool} from '../kb'

interface CheckboxLabelProps {
    id?: string
    children: ReactNode
    onChange?: ChangeEventHandler<HTMLInputElement>
    checked?: StringBool
    defaultChecked?: boolean
    value?: string|number
    indeterminate?: boolean
    className?: ClassValue
    style?: CSSProperties
    readOnly?: boolean
    disabled?: boolean
    title?: string
    testId?: string
}

export default function CheckboxLabel({id, children, onChange, checked, value = 1, indeterminate, className, style, readOnly, disabled, title, defaultChecked, testId}: CheckboxLabelProps) {
    testId = useTestId(testId)
    return (
        <label className={cn('checkable', className, disabled ? 'disabled' : null)} style={style} title={title} data-testid={testId}>
            <div className="checkable-inner">
                <Checkbox id={id} onChange={onChange} value={value} checked={toBool(checked)} indeterminate={indeterminate}
                          readOnly={readOnly} disabled={disabled} defaultChecked={defaultChecked}/>
                <span>{children}</span>
            </div>
        </label>
    )
}
